import React from 'react';
import { XIcon } from '@keplerco/core';
import { SelectedFilterOption } from './analytics-filters.models';
import { OptionButton } from '../../../components/general/option-button/option-button';
import { HorizontalScroller } from '../../../components/general/horizontal-scroller/horizontal-scroller';

export function FiltersOutlet({ selectedFilters, removeFilter }: { selectedFilters: SelectedFilterOption[]; removeFilter: (filter: SelectedFilterOption) => void }) {

  if (!selectedFilters.length) return <React.Fragment></React.Fragment>;

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
      <span>Filters:</span>
      <HorizontalScroller scrollItemsLength={selectedFilters.length}>
        {selectedFilters.map(filter => (
          <OptionButton
            key={`${filter.filterType}-${filter.slug}`}
            onClick={() => removeFilter(filter)}
            style={{ flexShrink: 0 }}
            small
          >
            {filter.name}
            <XIcon size={16} tone='text' />
          </OptionButton>
        ))}
      </HorizontalScroller>
    </div>
  );
}

